import { createFileRoute } from "@tanstack/react-router";
import AdminDemosPage from "@/pages/admin/demos";

export const Route = createFileRoute("/app/admin/demos")({
  component: AdminDemosPage,
});
